import React from "react";
import { useNavigate } from "react-router-dom";

// Imports
import SimpleWrapper from "../components/SimpleWrapper";
import { MdArrowBackIos } from "../utils/Icons";

const supportData = [
  {
    icon: "/assets/email-icon.svg",
    title: "Email Support",
    desc: "Our team can respond in real time",
    link: "support@finelabs.in",
  },
  {
    icon: "/assets/whatsapp-icon.svg",
    title: "Chat on Whatsapp",
    desc: "Available during working hours",
    link: "+91 9138923900 or click here",
  },
  {
    icon: "/assets/phone-icon.svg",
    title: "Call us directly",
    desc: "Available during working hours",
    link: "+91 91389 23900",
  },
];

const Support = () => {
  const navigate = useNavigate();
  return (
    <SimpleWrapper searchVisible={false} navigation={true}>
      <div className="w-full h-fit flex flex-col justify-center items-center mt-[7.5%] lg:mt-0">
      <div className="flex w-full justify-start lg:hidden" onClick={()=>navigate("/my-profile")}>
        <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
        <span>Back</span>
        </div>
        <span className="font-semibold lg:font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
          Reach out to us
        </span>
        <span className="font-semibold text-[5.25vw] lg:text-[1.75vw] text-textPrimaryColor">
          We’d Love To Hear From You
        </span>
      </div>
      {/* Large Screens */}
      <div className="w-full h-fit hidden lg:flex justify-between items-center">
        {supportData?.map((item, index) => (
          <div
            className="flex flex-col justify-center items-center"
            key={index}
          >
            <img src={item?.icon} alt="icon" className="mb-[5%]" />
            <p className="font-semibold text-[1vw] text-textPrimaryColor mb-[1%]">
              {item?.title}
            </p>
            <p className="font-normal text-[0.9vw] text-textSecondaryColor mb-[7.5%]">
              {item?.desc}
            </p>
            {item.title === "Email Support" && (
              <a
                href={`mailto:${item?.link}`}
                className="font-normal text-[0.9vw] text-primaryColor"
              >
                {item?.link}
              </a>
            )}
            {item.title === "Chat on Whatsapp" && (
              <a
                href={`https://wa.me/${item?.link}`}
                className="font-normal text-[0.9vw] text-primaryColor"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp
              </a>
            )}
            {item.title === "Call us directly" && (
              <a
                href={`tel:${item?.link}`}
                className="font-normal text-[0.9vw] text-primaryColor"
              >
                {item?.link}
              </a>
            )}
          </div>
        ))}
      </div>

      {/** Small Screens */}
      <div className="w-full h-fit flex flex-col justify-start items-center space-y-[7.5%] lg:hidden">
        {supportData?.map((item, index) => (
          <div
            className="flex flex-col justify-center items-center"
            key={index}
          >
            <img src={item?.icon} alt="icon" className="mb-[5%]" />
            <p className="font-semibold text-[4vw] text-textPrimaryColor mb-[1%]">
              {item?.title}
            </p>
            <p className="font-normal text-[3.5vw] text-textSecondaryColor mb-[7.5%]">
              {item?.desc}
            </p>
            {item.title === "Email Support" && (
              <a
                href={`mailto:${item?.link}`}
                className="font-normal text-[3.5vw] text-primaryColor"
              >
                {item?.link}
              </a>
            )}
            {item.title === "Chat on Whatsapp" && (
              <a
                href={`https://wa.me/${item?.link}`}
                className="font-normal text-[3.5vw] text-primaryColor"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp
              </a>
            )}
            {item.title === "Call us directly" && (
              <a
                href={`tel:${item?.link}`}
                className="font-normal text-[3.5vw] text-primaryColor"
              >
                {item?.link}
              </a>
            )}
          </div>
        ))}
      </div>
    </SimpleWrapper>
  );
};

export default Support;
